var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import AntTable from 'antd/lib/table';
import { Icon } from '@gerdau/hefesto';
import './Table.styles.scss';
var Table = function (_a) {
    var dataSource = _a.dataSource, columns = _a.columns, rowSelection = _a.rowSelection, _b = _a.expandedColumnPosition, expandedColumnPosition = _b === void 0 ? 'right' : _b, expandedColumnTitle = _a.expandedColumnTitle, expandedRowRender = _a.expandedRowRender, onExpand = _a.onExpand, _c = _a.pagination, pagination = _c === void 0 ? false : _c, _d = _a.rowClassName, rowClassName = _d === void 0 ? function (record, index) {
        return index % 2 === 0 ? '' : 'gray-background';
    } : _d, onChange = _a.onChange, scroll = _a.scroll;
    var tableRef = useRef(null);
    var canExpandRow = !!expandedRowRender;
    var startSortColumnHeader = function () {
        if (tableRef.current && canExpandRow) {
            var th = tableRef.current.querySelector('.ant-table-row-expand-icon-cell');
            if (th) {
                th.textContent = expandedColumnTitle || '';
            }
        }
    };
    var availableColumns = canExpandRow
        ? expandedColumnPosition === 'left'
            ? __spreadArray([AntTable.EXPAND_COLUMN], columns, true) : __spreadArray(__spreadArray([], columns, true), [AntTable.EXPAND_COLUMN], false)
        : columns;
    useEffect(function () {
        startSortColumnHeader();
    }, [expandedColumnTitle]);
    return (_jsx(AntTable, __assign({ ref: tableRef, locale: {
            triggerDesc: '',
            triggerAsc: '',
            cancelSort: '',
        }, className: "hefesto-table", dataSource: dataSource, columns: availableColumns, rowSelection: rowSelection, pagination: pagination, rowClassName: rowClassName, onChange: onChange }, (scroll ? { scroll: scroll } : {}), { expandable: canExpandRow
            ? {
                expandedRowRender: expandedRowRender,
                expandRowByClick: false,
                onExpand: onExpand,
                expandIcon: function (_a) {
                    var expanded = _a.expanded, onExpandIconClick = _a.onExpand, record = _a.record;
                    return (_jsx("div", __assign({ className: "hefesto-table--expand".concat(expanded ? 'Up' : 'Down'), onClick: function (e) { return onExpandIconClick(record, e); } }, { children: _jsx(Icon, { option: "ChevronDown" }) })));
                },
            }
            : undefined })));
};
export default Table;
